.head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--spacing-3);
  margin-bottom: var(--spacing-3);
}

/* Same size as the DS card headline. */
.title {
  margin: 0;
  flex: 1;
  min-width: 0;
  font-size: var(--font-size-xl);
  font-weight: inherit;
  color: var(--color-text);
}

.headActions {
  display: flex;
  align-items: center;
  gap: var(--spacing-2);
  flex-shrink: 0;
}

/* Diagnosis banner (same look as the former diagnosis card). */
.banner {
  display: flex;
  align-items: center;
  gap: var(--spacing-3);
  padding: var(--spacing-3) var(--spacing-4);
  border-radius: 10px;
  margin-bottom: var(--spacing-2);
}

.bannerOk {
  background: var(--color-success-lightest);
}

.bannerWarn {
  background: var(--color-warning-lightest);
}

.bannerErr {
  background: var(--color-error-lightest);
}

.bannerIc {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.bannerOk .bannerIc {
  background: var(--color-success);
}

.bannerWarn .bannerIc {
  background: var(--color-warning);
}

.bannerErr .bannerIc {
  background: var(--color-error);
}

.bannerTitle {
  font-size: var(--font-size-m);
  color: var(--color-text);
}

.bannerSub {
  font-size: var(--font-size-s);
  color: var(--color-grey);
  margin-top: 2px;
}

.stacked {
  display: inline-flex;
  flex-direction: column;
  align-items: flex-end;
  gap: var(--spacing-1);
}

.muted {
  font-size: var(--font-size-s);
  color: var(--color-grey);
}

.modalActions {
  display: flex;
  justify-content: flex-end;
  gap: var(--spacing-2);
  margin-top: var(--spacing-4);
}

/* Column widths for the three-column rows; the actions column never changes width. */
.rows {
  --detail-label-w: 170px;
  --detail-actions-w: 220px;
}
